import "../../../styles/QuestionOverviewModal.css";

import React from "react";
import locationIcon from "../../../assets/ic_location.svg";
import reviewBadge from "../../../assets/ic_review_badge.svg";
import unansweredIcon from "../../../assets/ic_rectangle.svg";

const QuestionOverviewModal = ({ isOpen, onClose, currentQuestion, totalQuestions, markedQuestions, answeredQuestions, onQuestionClick, onReviewPage, currentModule, currentSection }) => {
	if (!isOpen) return null;

	return (
		<div className='modal-overlay'>
			<div className='question-overview-modal'>
				<div className='modal-header'>
					<h4>Section 1, Module 1: Reading and Writing</h4>
					<button className='close-btn' onClick={onClose}>
						×
					</button>
				</div>

				<div className='legend'>
					<div className='legend-item'>
						<img src={locationIcon} alt='Current' className='current-icon' /> Current
					</div>
					<div className='legend-item'>
						<img src={unansweredIcon} alt='Review Badge' className='review-badge' /> Unanswered
					</div>
					<div className='legend-item'>
						<img src={reviewBadge} alt='Review Badge' className='review-badge' /> For Review
					</div>
				</div>

				<div className='questions-grid'>
					{[...Array(totalQuestions)]?.map((_, index) => {
						const questionNum = index + 1;
						const isMarked = markedQuestions.includes(questionNum);
						const isAnswered = answeredQuestions?.[currentSection]?.[currentModule]?.[questionNum];
						const isCurrent = currentQuestion === questionNum;

						return (
							<button key={questionNum} className={`question-button ${isAnswered ? "answered" : ""} ${isCurrent ? "current" : ""}`} onClick={() => onQuestionClick(questionNum)}>
								{questionNum}
								{isMarked && <img src={reviewBadge} alt='Review Badge' className='review-indicator' />}
								{isCurrent && <img src={locationIcon} alt='Current' className='current-indicator' />}
							</button>
						);
					})}
				</div>

				<div className='modal-footer'>
					<button className='review-page-btn' onClick={onReviewPage}>
						Go to review Page
					</button>
				</div>
			</div>
		</div>
	);
};

export default QuestionOverviewModal;
